import React, { useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Logo from './Logo.js';

const DrawerHeader = styled('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end'
}));
const Layout = props => {
  const {
    maxWidth = 1980,
    drawerWidth = 240,
    sidebarWidth = 350
  } = props;
  const {
    window,
    drawer,
    bgColor = 'primary.main'
  } = props;
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(true);
  const handleDrawerToggleMobile = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawerToggle = () => {
    setOpen(!open);
  };
  const container = window !== undefined ? () => window().document.body : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(AppBar, {
    sx: {
      width: {
        xl: `calc(100% - ${open && drawerWidth || 0}px)`
      },
      ml: {
        xl: `${open && drawerWidth || 0}px`
      },
      backgroundColor: bgColor
    }
  }, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "open drawer",
    edge: "start",
    onClick: () => {
      handleDrawerToggleMobile();
      handleDrawerToggle();
    },
    sx: {
      mr: 2,
      display: {
        xl: open ? 'none' : 'block'
      }
    }
  }, /*#__PURE__*/React.createElement(MenuIcon, null)), /*#__PURE__*/React.createElement(Logo, {
    variant: props.logoVariant || 'white',
    sx: {
      height: '40px',
      display: {
        sm: open ? 'none' : 'block',
        xs: 'none'
      },
      mr: 3
    }
  }), props.appBar), props.loading && /*#__PURE__*/React.createElement(LinearProgress, null)), /*#__PURE__*/React.createElement(Box, {
    component: "nav",
    sx: {
      width: {
        xl: open && drawerWidth || 0
      },
      flexShrink: {
        xl: 0
      }
    },
    "aria-label": "mailbox folders"
  }, /*#__PURE__*/React.createElement(Drawer, {
    container: container,
    variant: "temporary",
    open: mobileOpen,
    onClose: handleDrawerToggleMobile,
    ModalProps: {
      keepMounted: true // Better open performance on mobile.
    },
    sx: {
      display: {
        xs: 'block',
        xl: 'none'
      },
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        width: drawerWidth
      }
    }
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    sx: {
      backgroundColor: bgColor
    }
  }, /*#__PURE__*/React.createElement(Logo, {
    variant: props.logoVariant || 'white',
    sx: {
      height: '40px',
      mr: 'auto',
      ml: 1
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleDrawerToggleMobile,
    color: "inherit",
    sx: {
      color: 'white'
    }
  }, theme.direction === 'ltr' ? /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    sx: {
      color: 'white'
    }
  }) : /*#__PURE__*/React.createElement(ChevronRightIcon, {
    sx: {
      color: 'white'
    }
  }))), drawer), /*#__PURE__*/React.createElement(Drawer, {
    variant: "permanent",
    sx: {
      display: {
        xs: 'none',
        xl: 'block'
      },
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        width: open && drawerWidth || 0
      }
    },
    open: true
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    sx: {
      backgroundColor: bgColor
    }
  }, /*#__PURE__*/React.createElement(Logo, {
    variant: props.logoVariant || 'white',
    sx: {
      height: '40px',
      mr: 'auto',
      ml: 1
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleDrawerToggle,
    sx: {
      color: 'white'
    }
  }, theme.direction === 'ltr' ? /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    sx: {
      color: 'white'
    }
  }) : /*#__PURE__*/React.createElement(ChevronRightIcon, {
    sx: {
      color: 'white'
    }
  }))), drawer)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'block',
      width: '100%',
      height: '100%',
      minHeight: '100vh',
      backgroundColor: '#eee'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      height: '100%',
      display: 'flex',
      mx: {
        xs: 0,
        lg: 'auto'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'block',
      maxWidth: {
        xs: '100%',
        lg: `${maxWidth}px`
      },
      width: {
        xs: '100%',
        lg: `calc(100% - ${sidebarWidth}px)`
      },
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(DrawerHeader, null), props.children), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: {
        xs: '0',
        lg: `${sidebarWidth}px`
      },
      height: '100%',
      display: {
        xs: 'none',
        lg: 'block'
      }
    }
  }, /*#__PURE__*/React.createElement(DrawerHeader, null), props.sidebar)))), /*#__PURE__*/React.createElement(Paper, {
    className: "footer",
    sx: {
      justifyContent: 'center',
      align: 'center',
      width: '100%',
      py: 1,
      zIndex: 'drawer'
    },
    elevation: 3
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mx: "auto",
    flexWrap: "wrap"
  }, props.footer)));
};

export { Layout };
